import {Claim} from '../model/claim.model';
import {JsonProperty} from "../utilities/utils/json-property.decorator";
import {TransactionInfo} from "./transaction-info.model";
export class AutoSaveForm {

  private saveId: number;
  private staffId: string;
  private identifier: string;
  private policyNumber: string;
  private product: string;
  private transaction: string;
  private type: string;
  private entryUrl: string;
  private country: string;
  private language: string;
  private catalogueCode: string;
  private dateOfLoss: Date;

  @JsonProperty({name: 'claim', clazz: Claim})
  private claim: Claim = new Claim();

  @JsonProperty({name: 'transactionInfo', clazz: TransactionInfo})
  private transactionInfo: TransactionInfo = new TransactionInfo();


  getSaveId(): number {
    return this.saveId;
  }

  setSaveId(value: number) {
    this.saveId = value;
  }

  getStaffId(): string {
    return this.staffId;
  }

  setStaffId(value: string) {
    this.staffId = value;
  }

  getIdentifier(): string {
    return this.identifier;
  }

  setIdentifier(value: string) {
    this.identifier = value;
  }

  getPolicyNumber(): string {
    return this.policyNumber;
  }

  setPolicyNumber(value: string) {
    this.policyNumber = value;
  }

  getProduct(): string {
    return this.product;
  }

  setProduct(value: string) {
    this.product = value;
  }

  getTransaction(): string {
    return this.transaction;
  }

  setTransaction(value: string) {
    this.transaction = value;
  }

  getType(): string {
    return this.type;
  }

  setType(value: string) {
    this.type = value;
  }

  getClaim(): Claim {
    return this.claim;
  }

  setClaim(value: Claim) {
    this.claim = value;
  }

  getTransactionInfo(): TransactionInfo {
    return this.transactionInfo;
  }

  setTransactionInfo(value: TransactionInfo) {
    this.transactionInfo = value;
  }

  getEntryUrl(): string {
    return this.entryUrl;
  }

  setEntryUrl(value: string){
    this.entryUrl = value;
  }

  public getCountry(): string {
    return this.country;
  }

  public setCountry(value: string) {
    this.country = value;
  }

  public getLanguage(): string {
    return this.language;
  }

  public setLanguage(value: string) {
    this.language = value;
  }

  public getCatalogueCode(): string {
    return this.catalogueCode;
  }

  public setCatalogueCode(value: string) {
    this.catalogueCode = value;
  }

  public getDateOfLoss(): Date {
    return this.dateOfLoss;
  }

  public setDateOfLoss(value: Date) {
    this.dateOfLoss = value;
  }
}
